const MESSAGE_GROUPS_MAPPER: any = {
  cl62afzdjew3v0ck3epscx10c: 'https://chat.whatsapp.com/GWTa7M0Khe95kHBIoMHAbB', // Administração
  cl62ag3uwewj60ck3wa5qu88f: 'https://t.me/+IIljWhGk_uwyMjEx', // Análise e Desenvolvimento de Sistemas
  cl62agjsxewy60ck3gdvp4u46: 'https://chat.whatsapp.com/DjDvDoNOsdQFyA0GIBjIf0', // Ciência da Computação
  cl62agmyycybl0ck6krpsmdsm: 'https://chat.whatsapp.com/K1H0qAy1Y5KF10hHVsqr8K', // Ciência de Dados
  cl62ag05ucx7o0ck6zygzfj3l: 'https://t.me/+J3dlfpEtfsA0NWZh', // Ciências Contábeis
  cl62ag5cdd4kd0ckc6bn9k98m: 'https://t.me/+fSmUML5j_0NiMjgx', // Computação em Nuvem
  cl62aghpz62qa0bk2l54vyatz: 'https://chat.whatsapp.com/Bkd17YMexEh40UEXSPEkVk', // Engenharia da Computação
  cln99sqssdj8y0bkbm4lf7ohd: 'https://chat.whatsapp.com/LkMJz5UVczq6xImLikp5lq', // Engenharia de Software
  cl62agfq1cy170ck6sh178zsi: 'https://chat.whatsapp.com/F62aNYIs3oeInqx8nLnnXZ', // Gestão Financeira
  cl62ag6bcd4lk0ckcizm0iwkx: 'https://t.me/+wSxao9YOVcY5MTQx', // Jogos Digitais
  cl62agf29cy130ck60db87rtm: 'https://t.me/+WseyFhJUccw2ZWQx', // Logística
  cl62agdqr62ot0bk2r8kz3m6p: 'https://chat.whatsapp.com/D6eSoTy2ztZ0ScnfnL2DXV', // Marketing
  cl62agmbkd53w0ckcm1q75u1w: 'https://chat.whatsapp.com/FECQtefr93BAXZDPgKovlg', // Marketing Digital
  cl62afyfccx6e0ck6xi1mazld: 'https://t.me/+LYPmm1c1xtlhMWJh', // Pedagogia
  cl62ag10fd42c0ckc6ir57mi6: 'https://chat.whatsapp.com/HtBXErPsyytJbtuGf58b1f', // Recursos Humanos
  cl62ag8bsews60ck34ccfm16x: 'https://chat.whatsapp.com/Es6yPyqAVm94E9ftKTIWLY', // Sistemas de Informação
  cl62ag7d0d4ms0ckczd8zdokr: 'https://t.me/+hfUHqw1QuUI1ZmFh', // Sistemas para Internet
};

const TEST_MAPPER: any = {
  'abc-123': 'https://t.me/+M7jPyq588xc5MGIx', // Teste
  cl76h5pev1nr30biofp2thdj5: 'https://t.me/+M7jPyq588xc5MGIx', // Magia dos Magos
  cllmhlmpxfiul0ak4o6akj1v5: 'https://t.me/+M7jPyq588xc5MGIx', // CodeChoco
  cktvwdedse6wy0b232moikt4m: 'https://t.me/+M7jPyq588xc5MGIx', // Engenharia da Fera
};

export function getMessageGroupByCourseId(courseId: string): string | undefined {
  const isProduction = process.env.NODE_ENV === 'production';
  const url = isProduction ? MESSAGE_GROUPS_MAPPER[courseId] : TEST_MAPPER[courseId];

  return url;
}
